/**
 * Protocol finder (quiz) copy. Prefix: "qz."
 *
 * Same accuracy rules as the rest of the dictionary: never translate product
 * or ingredient names, doses, units, prices, pack sizes, certification names
 * or study references, and never strengthen a claim.
 */

export const quizFlow = {
  en: {
    "qz.finder": "TruWe protocol finder",
    "qz.step": "Step {n} of {total} · 2-minute quiz",

    "qz.q1.eyebrow": "Question 1",
    "qz.q1.title": "What's your primary goal today?",
    "qz.q1.sub": "Pick the one outcome that matters most right now.",
    "qz.q2.eyebrow": "Question 2",
    "qz.q2.title": "Which symptoms are you experiencing most?",
    "qz.q2.sub": "Tap all that apply, this sharpens your protocol.",
    "qz.q3.eyebrow": "Question 3",
    "qz.q3.title": "How long have you been dealing with these?",
    "qz.q3.sub": "Helps us set realistic timeline expectations.",
    "qz.q4.eyebrow": "Question 4",
    "qz.q4.title": "Any current supplements or medications?",
    "qz.q4.sub": "Quick safety check, we'll flag any interactions.",

    "qz.goal.energy": "Better Energy & Recovery",
    "qz.goal.energy.sub": "Fatigue, dips, slow recovery",
    "qz.goal.hormones": "Hormonal Balance & PCOS Support",
    "qz.goal.hormones.sub": "Cycles, acne, mood, weight",
    "qz.goal.liver": "Liver & Gut Health",
    "qz.goal.liver.sub": "Bloating, digestion, dull skin",
    "qz.goal.sleep": "Deeper Sleep & Recovery",
    "qz.goal.sleep.sub": "Restless nights, morning fog",
    "qz.goal.multiple": "I have multiple concerns",
    "qz.goal.multiple.sub": "Build a full daily protocol",

    "qz.sym.fatigue": "Low energy / fatigue",
    "qz.sym.poorSleep": "Poor sleep",
    "qz.sym.hormonalAcne": "Hormonal acne or irregular cycles",
    "qz.sym.bloating": "Bloating or digestion issues",
    "qz.sym.fogMood": "Brain fog or low mood",
    "qz.sym.crampsRecovery": "Muscle cramps or slow recovery",

    "qz.dur.lt1mo": "Less than a month",
    "qz.dur.1to3mo": "1-3 months",
    "qz.dur.3to6mo": "3-6 months",
    "qz.dur.6moPlus": "6+ months",

    "qz.supp.none": "No, nothing currently",
    "qz.supp.some": "Yes, I take some",
    "qz.supp.label": "Optional, what are you currently taking?",
    "qz.supp.placeholder": "e.g. Vitamin D, thyroid medication…",
    "qz.supp.note":
      "We use this only to surface safety notes. Always check with your doctor before starting any supplement alongside prescription medication.",

    "qz.back": "Back",
    "qz.continue": "Continue",
    "qz.seeProtocol": "See my protocol",

    "qz.loading.title": "Building your personalised protocol…",
    "qz.loading.sub": "Cross-referencing your answers with our clinical formulary.",

    "qz.result.eyebrow": "Your TruWe protocol",
    "qz.result.title": "Your Personalized {days}-Day Protocol",
    "qz.result.sub":
      "Built around your top goal and the symptoms you flagged. Clinically-studied actives, no fluff.",
    "qz.role.primary": "Primary",
    "qz.role.supporting": "Supporting",

    "qz.trio.eyebrow": "The TruWe Protocol",
    "qz.packs.eyebrow": "Choose your protocol length",
    "qz.packs.sub":
      "Clinical actives compound. Most people see the clearest change on a 60- or 90-day run.",
    "qz.packs.popular": "Most popular",
    "qz.packs.day": "{days}-day protocol",
    "qz.packs.perDay": "{n} {unit} · ₹{price}/day",
    "qz.packs.pack": "pack",
    "qz.packs.packs": "packs",

    "qz.cta.fullProtocol": "Your full protocol",
    "qz.cta.protocol": "Your protocol",
    "qz.cta.startingPoint": "Your recommended starting point",
    "qz.cta.save": "Save ₹{amount}",
    "qz.cta.emi": "No-cost EMI available on this order",
    "qz.cta.added": "Added, open cart",
    "qz.cta.addFull": "Add my full protocol to cart",
    "qz.cta.addProtocol": "Add my protocol to cart",
    "qz.cta.addToCart": "Add to cart",

    "qz.push.title": "Get your protocol reminders here",
    "qz.push.desc":
      "We'll ping this device with restock alerts and your dosing reminders. No spam.",

    "qz.lead.savedTitle": "Your protocol is saved",
    "qz.lead.savedAccount": "Saved to your account. Find it any time under",
    "qz.lead.savedAccountLink": "your account",
    "qz.lead.savedEmail": "We've emailed a copy so you can come back to it any time.",
    "qz.lead.title": "Email me this protocol",
    "qz.lead.sub":
      "Get your results, dosing schedule and what to expect, straight to your inbox.",
    "qz.lead.name": "Your name",
    "qz.lead.namePlaceholder": "Your name (optional)",
    "qz.lead.email": "Email address",
    "qz.lead.phone": "WhatsApp number",
    "qz.lead.phonePlaceholder": "WhatsApp number (optional)",
    "qz.lead.submit": "Email me my protocol",
    "qz.lead.invalidEmail": "Please enter a valid email address.",
    "qz.lead.saveFailed": "We couldn't save that. Please try again.",
    "qz.lead.sent": "Sent, your protocol is on its way to your inbox.",

    "qz.addons.title": "Adjust your protocol",
    "qz.addons.sub": "Add the rest of the TruWe daily ritual for a stacked benefit.",
    "qz.retake": "Retake the quiz",

    "qz.toast.loading": "Products are still loading, try again in a second.",
    "qz.toast.addFailed": "Couldn't add your protocol. Please try again.",
    "qz.toast.added": "Your protocol is in the cart",
  },
} as const;
